(function (ng, app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Contacts.ContactView.TimelineView",
                    {
                        url: "/TimelineView",
                        component: "timelineView",
                        PageTitle: "Contact Timeline | Marketing Tracker"
                    });
        }
    ]);


    app
        .component("timelineView",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Contacts/ContactView/TimelineView/timeline-view-template.html",
                controller: timelineViewController,
                bindings: {
                    contactId: "<",
                    contactEmail: "<"
                }
            });

    timelineViewController.$inject = [
        "figToaster",
        "marketingTrackerConstantContactApi",
        "marketingTrackerContactApi",
        "marketingTrackerEventResponderApi",
        "marketingTrackerRMEApi",
        "$q"
    ];
    function timelineViewController(
        figToaster,
        marketingTrackerConstantContactApi,
        marketingTrackerContactApi,
        marketingTrackerEventResponderApi,
        marketingTrackerRMEApi,
        $q
    ) {
        const $ctrl = this;
        window.home = this;
        ng.extend($ctrl,
            {
                ui: {
                    loadingData: true,
                    loadingActivity: true
                },
                activitiesContainer: [],
                contactActivities: []
            });

        function _getContact(contactId) {
            $ctrl.ui.loadingData = true;
            marketingTrackerContactApi.getContactById(contactId)
                .then(function (response) {
                    $ctrl.contact = response;
                    _getAllActivities(response);
                })
                .catch(function (error) {
                    console.log("Error: " + error.data);
                    var message = "There was a problem retrieving your data. Please try again shortly.";
                    var toastClass = "is-error";
                    figToaster.showSimple(message, "top", toastClass);
                })
                .finally(function () {
                    $ctrl.ui.contactUpdates = ng.copy($ctrl.contact);
                    $ctrl.ui.loadingData = false;
                });
        }

        function _getAllActivities(contact) {
            var promises = [];
            $ctrl.ui.loadingActivity = true;

            switch (contact.Origin) {
                case 'ConstantContact':
                    promises.push(_getConstantContactActivity(contact.ConstantContactId));
                    break;
                case 'Rme':
                    promises.push(_getRMEActivity(contact.RmeId));
                    break;
                case 'GenericSpreadsheet':
                    promises.push(_getResponderActivity(contact.Email));
                    break;
                default:
                    break;
            }

            // below can be used if we want to coalesce all different activity sources, 
            // but we would need to refactor generic to seperate out rme uploaded results

            //if (contact.ConstantContactId) {
            //    promises.push(_getConstantContactActivity(contact.ConstantContactId));
            //}

            //if (contact.ActOnId) {
            //    promises.push(_getActOnActivity(contact.ActOnId));
            //}

            //if (contact.RmeId) {
            //    promises.push(_getRMEActivity(contact.RmeId));
            //}

            //if (contact.Origin === "GenericSpreadsheet") {
            //    promises.push(_getResponderActivity(contact.Email));
            //}

            $q.all(promises)
                .then(function () {
                    renameActivity($ctrl.activitiesContainer);
                })
                .catch(function (error) {
                    console.log("Error: ", error);
                })
                .finally(function () {
                    $ctrl.contactActivities = $ctrl.activitiesContainer;
                    $ctrl.ui.loadingActivity = false;
                });
        }

        function _getConstantContactActivity(contactId) {
            return marketingTrackerConstantContactApi.getActivityByContactId(contactId)
                .then(function (response) {
                    response.forEach(function (a) {
                        a.Origin = "CC";
                        $ctrl.activitiesContainer.push(a);
                    },
                        this);
                });
        }

        //function _getActOnActivity(actOnId) {
        //var test = {
        //    "activity":
        //    {
        //        "lastInbound": "Today", "ScorePeriod": "all time", "lastOutbound": "6 Days Ago",
        //        "ScoreDetails": [
        //            { "id": "s-0001-1910", "idType": "msg", "specific": false, "profile": false, "action": "MESSAGE_SEND", "score": 30 },
        //            { "id": "s-0003-1910", "idType": "msg", "specific": false, "profile": false, "action": "MESSAGE_SEND", "score": 30 },
        //            { "id": "s-0002-1910", "idType": "msg", "specific": false, "profile": false, "action": "MESSAGE_SEND", "score": 30 },
        //            { "id": "e8e1da5d-f55f-4506-997d-38bf14782726", "idType": "form", "specific": false, "profile": false, "action": "FORM_SUBMIT", "score": 30 },
        //            { "id": "e8e1da5d-f55f-4506-997d-38bf14782726", "idType": "form", "specific": false, "profile": false, "action": "FORM_SUBMIT", "score": 30 },
        //            { "id": "e8e1da5d-f55f-4506-997d-38bf14782726", "idType": "form", "specific": false, "profile": false, "action": "FORM_SUBMIT", "score": 30 },
        //            { "id": "kyleci61.actonservice.com/acton/fs/blocks/showLandingPage/a/42415/p/p-0002/t/page/fm/0", "idType": "web", "specific": false, "profile": false, "action": "WEB_VISIT", "score": 30 },
        //            { "id": "kyleci61.actonservice.com/acton/fs/blocks/showLandingPage/a/42415/p/p-0002/t/page/fm/0", "idType": "web", "specific": false, "profile": false, "action": "WEB_VISIT", "score": 30 },
        //            { "id": "aotest.com/kansted-wp/index.php/2019/08/20/test-beacon/", "idType": "web", "specific": false, "profile": false, "action": "WEB_VISIT", "score": 30 }],
        //        "score": 270, "entries": [], "firstOutbound": "7 Days Ago", "EntryMonthsAvailable": ["1909", "1910"], "HasProfileScore": false, "HasScoreSheet": true, "HasBehaviorScore": true, "firstInbound": "13 Days Ago"
        //    },
        //    "activitylist": [
        //        { "Bin": "FORM", "InScoreRange": true, "d": "14", "WhenMillis": 1571097511000, "What": "Submitted: Example", "Verb": "fs", "m": "Oct", "ago": "0", "Icon": "silk/application_form_add.png", "y": "19", "Responses": [], "id": "e8e1da5d-f55f-4506-997d-38bf14782726", "idType": "form" },
        //        { "Bin": "FORM", "InScoreRange": true, "d": "14", "WhenMillis": 1571097508000, "What": "Viewed: Example", "Verb": "fv", "m": "Oct", "ago": "0", "Icon": "silk/application_form.png", "y": "19", "Responses": [], "id": "e8e1da5d-f55f-4506-997d-38bf14782726", "idType": "form" },
        //        { "Bin": "WEB", "InScoreRange": true, "d": "14", "WhenMillis": 1571097507000, "What": "Landing Page Visit: Exampletest", "Verb": "l", "m": "Oct", "ago": "0", "Icon": "16page_visitor.gif", "y": "19", "Responses": [], "id": "p-0002", "idType": "landing" },
        //        { "Bin": "SITE", "InScoreRange": true, "d": "14", "WhenMillis": 1571097467000, "What": "Website Visit", "Verb": "b", "m": "Oct", "ago": "0", "Icon": "silk/page_white_world.png", "y": "19", "Responses": [] },
        //        { "Bin": "WEB", "InScoreRange": true, "d": "14", "WhenMillis": 1571097467000, "What": "Web Page Visit: aotest.com/kansted-wp/index.php/2019/08/20/test-beacon/", "Verb": "b", "m": "Oct", "ago": "0", "Icon": "silk/page_white_world.png", "y": "19", "Responses": [], "id": "aotest.com/kansted-wp/index.php/2019/08/20/test-beacon/", "idType": "web" },
        //        {"Bin": "EMAIL", "InScoreRange": true, "d": "8", "WhenMillis": 1570579568000, "What": "Sent: Example", "Verb": "os", "m": "Oct", "ago": "6", "Icon": "env-opened.jpg", "y": "19", "Responses": [], "id": "s-0003-1910", "idType": "msg"},
        //        { "Bin": "FORM", "InScoreRange": true, "d": "8", "WhenMillis": 1570573776000, "What": "Submitted: Example", "Verb": "fs", "m": "Oct", "ago": "6", "Icon": "silk/application_form_add.png", "y": "19", "Responses": [], "id": "e8e1da5d-f55f-4506-997d-38bf14782726", "idType": "form" },
        //        { "Bin": "FORM", "InScoreRange": true, "d": "8", "WhenMillis": 1570573773000, "What": "Viewed: Example", "Verb": "fv", "m": "Oct", "ago": "6", "Icon": "silk/application_form.png", "y": "19", "Responses": [], "id": "e8e1da5d-f55f-4506-997d-38bf14782726", "idType": "form" },
        //        { "Bin": "WEB", "InScoreRange": true, "d": "8", "WhenMillis": 1570573773000, "What": "Web Page Visit: Landing Page: Exampletest", "Verb": "b", "m": "Oct", "ago": "6", "Icon": "silk/page_white_world.png", "y": "19", "Responses": [], "id": "kyleci61.actonservice.com/acton/fs/blocks/showLandingPage/a/42415/p/p-0002/t/page/fm/0", "idType": "web" },
        //        { "Bin": "SITE", "InScoreRange": true, "d": "8", "WhenMillis": 1570573772000, "What": "Website Visit", "Verb": "b", "m": "Oct", "ago": "6", "Icon": "silk/page_white_world.png", "y": "19", "Responses": [] }, { "Bin": "WEB", "InScoreRange": true, "d": "8", "WhenMillis": 1570573772000, "What": "Landing Page Visit: Exampletest", "Verb": "l", "m": "Oct", "ago": "6", "Icon": "16page_visitor.gif", "y": "19", "Responses": [], "id": "p-0002", "idType": "landing" },
        //        { "Bin": "FORM", "InScoreRange": true, "d": "7", "WhenMillis": 1570517391000, "What": "Submitted: Example", "Verb": "fs", "m": "Oct", "ago": "7", "Icon": "silk/application_form_add.png", "y": "19", "Responses": [], "id": "e8e1da5d-f55f-4506-997d-38bf14782726", "idType": "form" },
        //        { "Bin": "FORM", "InScoreRange": true, "d": "7", "WhenMillis": 1570517388000, "What": "Viewed: Example", "Verb": "fv", "m": "Oct", "ago": "7", "Icon": "silk/application_form.png", "y": "19", "Responses": [], "id": "e8e1da5d-f55f-4506-997d-38bf14782726", "idType": "form" },
        //        { "Bin": "WEB", "InScoreRange": true, "d": "7", "WhenMillis": 1570517388000, "What": "Web Page Visit: Landing Page: Exampletest", "Verb": "b", "m": "Oct", "ago": "7", "Icon": "silk/page_white_world.png", "y": "19", "Responses": [], "id": "kyleci61.actonservice.com/acton/fs/blocks/showLandingPage/a/42415/p/p-0002/t/page/fm/0", "idType": "web" },
        //        { "Bin": "WEB", "InScoreRange": true, "d": "7", "WhenMillis": 1570517387000, "What": "Landing Page Visit: Exampletest", "Verb": "l", "m": "Oct", "ago": "7", "Icon": "16page_visitor.gif", "y": "19", "Responses": [], "id": "p-0002", "idType": "landing" },
        //        { "Bin": "DOC", "InScoreRange": true, "d": "7", "WhenMillis": 1570516677000, "What": "Downloaded: test", "Verb": "d", "m": "Oct", "ago": "7", "Icon": "arrow_download.gif", "y": "19", "Responses": [], "id": "u-48aaa2da-1381-4e4d-b942-e6c1b71b73bf", "idType": "doc" },
        //        { "Bin": "EMAIL", "InScoreRange": true, "d": "7", "WhenMillis": 1570516669000, "What": "Sent: Example", "Verb": "os", "m": "Oct", "ago": "7", "Icon": "env-opened.jpg", "y": "19", "Responses": [{ "InScoreRange": true, "Description": "test", "Action": "Clickthrough", "ResponseAfter": "on Oct 7" }], "id": "s-0002-1910", "idType": "msg" },
        //        { "Bin": "DOC", "InScoreRange": true, "d": "7", "WhenMillis": 1570516339000, "What": "Downloaded: test", "Verb": "d", "m": "Oct", "ago": "7", "Icon": "arrow_download.gif", "y": "19", "Responses": [], "id": "u-48aaa2da-1381-4e4d-b942-e6c1b71b73bf", "idType": "doc" },
        //        { "Bin": "SITE", "InScoreRange": true, "d": "7", "WhenMillis": 1570516339000, "What": "Website Visit", "Verb": "b", "m": "Oct", "ago": "7", "Icon": "silk/page_white_world.png", "y": "19", "Responses": [] },
        //        { "Bin": "EMAIL", "InScoreRange": true, "d": "7", "WhenMillis": 1570492739000, "What": "Sent: Example Email", "Verb": "os", "m": "Oct", "ago": "7", "Icon": "env-opened.jpg", "y": "19", "Responses": [{ "InScoreRange": true, "Description": "CLICK", "Action": "Clickthrough", "ResponseAfter": "on Oct 7" }], "id": "s-0001-1910", "idType": "msg" },
        //        { "Bin": "DOC", "InScoreRange": true, "d": "30", "WhenMillis": 1569908654000, "What": "Downloaded: test", "Verb": "d", "m": "Sep", "ago": "14", "Icon": "arrow_download.gif", "y": "19", "Responses": [], "id": "u-48aaa2da-1381-4e4d-b942-e6c1b71b73bf", "idType": "doc" }, { "Bin": "DOC", "InScoreRange": true, "d": "30", "WhenMillis": 1569908595000, "What": "Downloaded: TEST", "Verb": "d", "m": "Sep", "ago": "14", "Icon": "arrow_download.gif", "y": "19", "Responses": [], "id": "u-86572cfa-575f-49a7-a743-246bb68d20c7", "idType": "doc" },
        //        { "Bin": "SITE", "InScoreRange": true, "d": "30", "WhenMillis": 1569908595000, "What": "Website Visit", "Verb": "b", "m": "Sep", "ago": "14", "Icon": "silk/page_white_world.png", "y": "19", "Responses": [] }]
        //};
        //marketingTrackerActOnApi.getActOnContactActivity(actOnId)
        //    .then(function (response) {
        //        response.activity.scoreDetails.forEach(function (a) {
        //            a.activity_type = a.action;
        //            aoActivity.push(a);
        //        }, this);
        //        console.log(response.results);
        //    }).then(function () {
        //        renameActivity($ctrl.contactActivities);
        //    })
        //    .finally(function () {
        //        aoActivity
        //    });
        //console.log($ctrl.contactActivities);
        //}

        //generic responder activity
        function _getResponderActivity(email) {
            return marketingTrackerEventResponderApi.getResponderEventActivity(email)
                .then(function (response) {
                    response.forEach(function (a) {
                        a.Origin = "GenericSpreadsheet";
                        a.activity_date = a.EventDate;
                        $ctrl.activitiesContainer.push(a);
                    });
                });
        }

        function _getRMEActivity(rmeId) {
            return marketingTrackerRMEApi.getRMEContactActivity(rmeId)
                .then(function (response) {
                    response.forEach(function (a) {
                        a.Origin = "RME";
                        a.activity_date = a.EventDate;
                        $ctrl.activitiesContainer.push(a);
                    },
                        this);
                });
        }

        function renameActivity(activityList) {
            _.forEach(activityList, function (activity) {
                switch (activity.activity_type) {
                    case 'EMAIL_SEND':
                        activity.activity_type = 'Received email';
                        break;
                    case 'EMAIL_CLICK':
                        activity.activity_type = 'Clicked on email';
                        break;
                    case 'EMAIL_OPEN':
                        activity.activity_type = 'Opened email';
                        break;
                    case 'EMAIL_FORWARD':
                        activity.activity_type = 'Forwarded email';
                        break;
                    case 'EMAIL_UNSUBSCRIBE':
                        activity.activity_type = 'Unsubscribed from email campaign';
                        break;
                    case 'EMAIL_BOUNCE':
                        activity.activity_type = 'Email bounced';
                    //    break;
                    //case 'Attended':
                    //    activity.activity_type = 'Did not attend';

                }
            });
        }

        $ctrl.$onInit = function () {
            _getContact($ctrl.contactId);
        };
    }

})(window.angular, window.app); //jshint ignore:line